module.exports = __webpack_public_path__ + "1bd9f348074fd35929ffdc08540c0d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/008.jpg
// module id = 11
// module chunks = 0